import { useEffect, useState } from "react";
import { X, Share, Plus, Smartphone } from "lucide-react";

const CLE = "odys_install_dismissed";

/** Banniere discrete "Ajouter a l'ecran d'accueil" (Android : prompt natif, iOS : mode d'emploi). */
export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    const deja = localStorage.getItem(CLE);
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (deja || standalone) return;

    const estIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const mobile = window.matchMedia("(max-width: 820px)").matches;
    if (estIos && mobile) {
      setIos(true);
      const t = setTimeout(() => setVisible(true), 6000);
      return () => clearTimeout(t);
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const fermer = () => {
    localStorage.setItem(CLE, "1");
    setVisible(false);
  };

  const installer = async () => {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    fermer();
  };

  if (!visible) return null;

  return (
    <div className="ip-bar" data-testid="install-prompt">
      <span className="ip-icon"><Smartphone className="w-4 h-4" /></span>
      <div className="ip-text">
        <strong>Installe Odys'IA sur ton telephone</strong>
        {ios ? (
          <span>
            Appuie sur <Share className="w-3 h-3 inline-block mx-0.5" /> Partager, puis
            <Plus className="w-3 h-3 inline-block mx-0.5" /> "Sur l'ecran d'accueil"
          </span>
        ) : (
          <span>Acces en un geste, plein ecran, sans barre de navigateur</span>
        )}
      </div>
      {!ios && (
        <button type="button" className="ip-cta" onClick={installer} data-testid="install-prompt-cta">
          Installer
        </button>
      )}
      <button type="button" className="ip-close" onClick={fermer} data-testid="install-prompt-close" aria-label="Fermer">
        <X className="w-4 h-4" />
      </button>

      <style>{`
        .ip-bar {
          position: fixed; left: 0.6rem; right: 0.6rem;
          bottom: calc(0.6rem + env(safe-area-inset-bottom, 0px));
          z-index: 60; display: flex; align-items: center; gap: 0.6rem;
          padding: 0.7rem 0.8rem; border-radius: 12px;
          background: var(--ink, #16233b); color: #faf7f1;
          box-shadow: 0 12px 30px rgba(0,0,0,0.28);
          font-family: var(--sans); animation: ip-in 0.25s ease-out;
        }
        @keyframes ip-in { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
        .ip-icon {
          flex: none; width: 2rem; height: 2rem; border-radius: 8px; display: flex;
          align-items: center; justify-content: center;
          background: rgba(181,137,74,0.22); color: var(--gold, #b5894a);
        }
        .ip-text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
        .ip-text strong { font-size: 0.8rem; font-weight: 600; }
        .ip-text span { font-size: 0.7rem; opacity: 0.8; line-height: 1.35; }
        .ip-cta {
          flex: none; background: var(--gold, #b5894a); color: #fff; border: none;
          border-radius: 6px; padding: 0.5rem 0.8rem; font-size: 0.78rem; font-weight: 600;
        }
        .ip-close {
          flex: none; background: transparent; border: none; color: rgba(250,247,241,0.6);
          width: 2rem; height: 2rem; display: flex; align-items: center; justify-content: center;
        }
        @media (min-width: 821px) { .ip-bar { display: none; } }
      `}</style>
    </div>
  );
}
